import { useGroups } from '@hooks/apis/groups';
import { getCampaignId, getGroupType } from './utils';
import { LineItem } from '@local-types';

export const useBWOverride = (adGroup: LineItem) => {
  const campaignId = getCampaignId(adGroup);
  const groupType = getGroupType(adGroup);

  const { update: updateGroup } = useGroups(groupType, campaignId, {
    params: {
      queryProps: {
        sync: 1,
      },
    },
  });

  const handleBWOverride = async () => {
    await updateGroup({
      id: adGroup.id,
      params: { targeting_override: 1 },
    });
  };

  return {
    handleBWOverride,
  };
};
